import { Box, styled } from '@ltvco/refresh-lib/theme';

interface ButtonBoxContainerProps {
  disabled?: boolean;
}

export const ButtonBoxContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'disabled',
})<ButtonBoxContainerProps>(({ theme, disabled }) => ({
  backgroundColor: disabled
    ? theme.palette.rats.light
    : theme.palette.primary.light,
  padding: theme.spacing(1),
  borderRadius: theme.spacing(1),
  border: '1px solid',
  borderColor: disabled
    ? theme.palette.rats.light
    : theme.palette.primary.light,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  margin: '12px 0',

  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
}));
